var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBoxMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 191,
    viewBox: "0 0 291 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 43.8486,
    width: 93.0137,
    height: 146.829,
    rx: 15,
    fill: "#FFF8B8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 235.191,
    width: 55.8082,
    height: 94.3425,
    rx: 15,
    fill: "#D2F7FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.637,
    y: 15.9453,
    width: 120.253,
    height: 174.733,
    rx: 15,
    fill: "#E4F5F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 235.191,
    y: 103.645,
    width: 55.8082,
    height: 87.0342,
    rx: 15,
    fill: "#FFD8F3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.57,
    cy: 72.0857,
    r: 15.613,
    fill: "#F7EFAF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.195,
    cy: 47.5033,
    r: 14.9486,
    fill: "#CBEBE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 104.309H76.4036",
    stroke: "#F6EFAF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 120.917H76.4036",
    stroke: "#F6EFAF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 137.527H76.4036",
    stroke: "#F6EFAF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.896 82.3838H202.636",
    stroke: "#CBEBE5",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.896 102.314H202.636",
    stroke: "#CBEBE5",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.896 122.247H202.636",
    stroke: "#CBEBE5",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.896 142.178H202.636",
    stroke: "#CBEBE5",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 154.137H50.4926",
    stroke: "#F6EFAF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.896 162.109H170.081",
    stroke: "#CBEBE5",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.15 119.589H279.041",
    stroke: "#EFC8E4",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.15 19.9316H279.041",
    stroke: "#C6ECF4",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.15 131.548H279.041",
    stroke: "#EFC8E4",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M247.15 144.172H273.061",
    stroke: "#EFC8E4",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M247.15 31.8896H279.041",
    stroke: "#C6ECF4",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M247.15 44.5137H273.061",
    stroke: "#C6ECF4",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBoxMobile);
export default __webpack_public_path__ + "static/media/HomeBox-mobile.94a8bfbf363db591c8660f5e21c512ea.svg";
export { ForwardRef as ReactComponent };